import { gql } from 'graphql-request';
import { merchantServiceGraphql, userToken } from '../config/Config';

export const getListCategory = async () => {
  try {
    const ALL_CATEGORY = gql`
      query AllCategories {
        allCategories {
          id
          description
          name
          parentID
          status
          created_at
          created_by
          updated_at
        }
      }
    `;
    const requestHeaders = {
      authorization: userToken,
    };
    const response = await merchantServiceGraphql.request(
      ALL_CATEGORY,
      {},
      requestHeaders
    );
    return response.allCategories;
  } catch (err) {
    return err;
  }
};

export const updateStatusCategory = async (data, password) => {
  const UPDATE_STATUS_CATEGORY = gql`
    mutation UpdateStatusCategory(
      $updateStatusCategoryId: Int!
      $status: Int!
    ) {
      updateStatusCategory(id: $updateStatusCategoryId, status: $status) {
        id
        status
      }
    }
  `;
  const requestHeaders = {
    authorization: userToken,
    Password: password,
  };

  const response = await merchantServiceGraphql.request(
    UPDATE_STATUS_CATEGORY,
    data,
    requestHeaders
  );
  return response.updateStatusCategory;
};
